<template>
  <div>
    <footer id="footer" class="footer">
      <div class="container">
        <div class="columns">
          <div class="column is-one-quarter content">
            <h5>COI Solutions, {{getYear()}}</h5>
            <div>
              <p>We help independent insurance brokers automate certificate of insurance requests.</p>
              <a class=" is-small" @click="showContactForm = true">
                <span class="icon is-small">
                  <i class="fa fa-envelope-o"></i>
                </span>
                <span>Contact Us</span>
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
    <div class="modal" :class="{'is-active': showContactForm}">
      <div class="modal-background"></div>
      <div class="modal-card">
        <header class="modal-card-head">
          <p class="modal-card-title">Contact Us</p>
          <button @click="showContactForm = false" class="delete"></button>
        </header>
        <div v-if="!contactSuccess">
          <section class="modal-card-body">
            <div class="content">
              <div class="field">
                <label class="label">Email Address</label>
                <div class="control">
                  <input class="input" type="text" v-model="contact.email" placeholder="Enter your email address">
                </div>
              </div>
              <!--               <div class="field">
                <label class="label">Name</label>
                <div class="control">
                  <input class="input" type="text" v-model="contact.name" placeholder="Enter your name">
                </div>
              </div>
              <div class="field">
                <label class="label">Phone Number</label>
                <div class="control">
                  <input class="input" type="text" v-model="contact.phone" placeholder="Enter your phone number">
                </div>
              </div> -->
              <div class="field">
                <label class="label">Message</label>
                <div class="control">
                  <textarea class="textarea" v-model="contact.message" placeholder="Enter your message, we'll respond as quickly as possible"></textarea>
                </div>
              </div>
            </div>
          </section>
          <footer class="modal-card-foot">
            <a class="button is-success" @click="sendContactMessage(contact)">Send</a>
            <a @click="showContactForm = false" class="button">Cancel</a>
          </footer>
        </div>
        <div v-if="contactSuccess">
          <section class="modal-card-body">
            Thank you for contacting us. We will return your message as soon as possible.
            </br>
            </br>
          </section>
          <footer class="modal-card-foot">
            <a @click="showContactForm = false" class="button">Close</a>
          </footer>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import axios from 'axios'
  export default {
    name: 'Footer',
    data: function () {
      return {
        showContactForm: false,
        contactSuccess: false,
        contact: {
          name: '',
          email: '',
          phone: '',
          message: ''
        }
      }
    },
    methods: {
      getYear() {
        return new Date().getFullYear()
      },
      sendContactMessage(contact) {
        let message = `New Contact Us request` +
          `\nEmail: ` + contact.email +
          `\n` + contact.message
        axios.post(process.env.API_BASE_URL + '/api/contact-us', message)
          .then(() => {
            this.contactSuccess = true
          }).catch((error) => {
            this.contactSuccess = true
            console.log(error)
          })
      }
    }
  }

</script>

<style scoped>
  #footer {
    padding: 4rem;
  }
</style>


// WEBPACK FOOTER //
// src/Footer.vue?3d2195bb